import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Users() {
  const [users, setUsers] = useState([]);
  const [showPassword, setShowPassword] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!loggedIn) {
      navigate('/login');
    }
    document.title = "Hotel Atlanta | Users";
    const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
    setUsers(storedUsers);
    setShowPassword(new Array(storedUsers.length).fill(false));
  }, [navigate]);

  const clearUsers = () => {
    localStorage.removeItem('users');
    setUsers([]);
    alert("All users cleared.");
  };

  const handleDelete = (index) => {
    const updated = users.filter((_, i) => i !== index);
    localStorage.setItem('users', JSON.stringify(updated));
    setUsers(updated);
    setShowPassword(prev => prev.filter((_, i) => i !== index));
  };

  const togglePassword = (index) => {
    const updated = [...showPassword];
    updated[index] = !updated[index];
    setShowPassword(updated);
  };

  return (
    <div className="container py-3">
      <h1 className="l-heading">
        <span className="text-primary">Registered</span> Users
      </h1>

      {users.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <div style={{ width: '1150px', margin: '0 auto', transform: 'translateX(50px)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
            <thead>
              <tr>
                <th style={{ padding: '10px', border: '1px solid #ccc', backgroundColor: '#f7c08a' }}>Username</th>
                <th style={{ padding: '10px', border: '1px solid #ccc', backgroundColor: '#f7c08a' }}>Password</th>
                <th style={{ width: '1%', padding: '0', border: 'none' }}></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, i) => (
                <tr key={i}>
                  <td style={{ padding: '10px', border: '1px solid #ccc' }}>{u.username}</td>
                  <td style={{
                    padding: '10px',
                    border: '1px solid #ccc',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <span>{showPassword[i] ? u.password : '••••••'}</span>
                    <button
                      onClick={() => togglePassword(i)}
                      style={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: '#ccc',
                        border: 'none',
                        fontSize: '12px',
                        cursor: 'pointer',
                        marginLeft: '10px'
                      }}
                    >
                      {showPassword[i] ? 'Hide' : 'Show'}
                    </button>
                  </td>
                  <td style={{ padding: '0 10px', border: 'none', textAlign: 'center', width: '1%' }}>
                    <button
                      onClick={() => handleDelete(i)}
                      style={{
                        backgroundColor: '#e74c3c',
                        color: '#fff',
                        border: 'none',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        cursor: 'pointer'
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
  <button onClick={clearUsers} className="btn">
    Clear Users
  </button>
</div>
    </div>
  );
}

export default Users;